/**
 * The number of postings we'll retrieve per page.
 *
 * @type {number}
 */
import { EMBER_ROUTE_NAMES } from "../routes";
import { APPLICATION } from "../../models/application";

/**
 * Number of applications to fetch per page.
 *
 * @type {number}
 */
export const POSTING_APPLICATIONS_PER_PAGE = 10;

/**
 * The list of statuses where we can show the expiration timer/relative text on a project.
 *
 * @type {string[]}
 */
export const POSTING__APPLICATION_EXPIRATION_STATUSES_ALLOWED = [
  APPLICATION.STATUS.PENDING
];

/**
 * Number of days we warn of upcoming expiration for
 *
 * @type {number}
 */
export const POSTING__APPLICATION_EXPIRATION_SHOW_FOR_DAYS = 3;

/**
 * @type {string[]}
 */
export const POSTING__ASSIGNMENT_BUYER_INCLUDES = [
  'assignment-deliverables',
  'assignment-schedules',
  'candidate-location',
  'classifications',
  'cost-code',
  'location',
  'services',
  'followers',
  'buyer',
  'buyer.company',
  'company-team',
];

/**
 * @type {string[]}
 */
export const POSTING__ASSIGNMENT_SELLER_INCLUDES = [
  'assignment-questions',
  'assignment-deliverables',
  'assignment-schedules',
  'brand.image',
  'candidate-location',
  'classifications',
  'location',
  'services',
  'followers',
  'buyer',
  'buyer.company',
];

/**
 * @type {string[]}
 */
export const POSTING__APP_SELLER_INCLUDES = [
  'seller',
  'buyer',
  'legal-agreements.legal',
  'application-deliverables',
  'application-details.location',
  'application-schedules',
  'assignment',
  'assignment.assignment-deliverables',
  'assignment.assignment-schedules',
  'assignment.candidate-location',
  'assignment.location',
  'assignment.services',
  'assignment.followers',
  'assignment.buyer',
  'assignment.buyer.company',
  'brand.image',
  'location',
  'pitch',
];

/**
 * Number of characters we'll allow before sending a request.
 *
 * @type {number}
 */
export const POSTING_SEARCH_CHARACTERS_BEFORE_REQUEST = 1;

/**
 * Number of applications to feature when sorted by POSTING_APPLICATIONS_SORT_API_ENUMS.USER_SEARCH_RANK.
 *
 * @type {number}
 */
export const POSTING_APPLICATIONS_FEATURED_COUNT = 5;

/**
 * The human readable 'assignment' sort options
 *
 * @type {Object}
 */
export const POSTING_APPLICATIONS_SORT_OPTIONS = {
  USER_SEARCH_RANK: 'Best',
  DATE_STARTED: 'Date started',
  LAST_ACTIVITY: 'Last activity',
  NEEDS_ACTION: 'Needs action',
  UNREAD_MESSAGES: 'Unread messages'
};

/**
 * API Enum strings that we'll be passing down to the api for the sort
 *
 * @type {Object}
 */
export const POSTING_APPLICATIONS_SORT_API_ENUMS = {
  DATE_STARTED: 'date-started',
  LAST_ACTIVITY: 'last-activity',
  NEEDS_ACTION: 'needs-action',
  UNREAD_MESSAGES: 'unread-messages',
  USER_SEARCH_RANK: 'user-search-rank',
};

/**
 * The navigation titles for the Posting Detail View e.g. posting/123/pending and etc.
 *
 * @type {Object}
 */
export const POSTING_APPLICATIONS_NAV_TITLES = {
  PENDING: 'Pending',
  HIRED: 'Hired',
  DECLINED: 'Declined'
};

/**
 * Map of PostingNavTitle => Ember Route Name for that nav title
 *
 * @type {Object}
 */
export const POSTING_APPLICATIONS_NAV_TITLES_TO_ROUTES_MAP = {
  [POSTING_APPLICATIONS_NAV_TITLES.PENDING] : EMBER_ROUTE_NAMES.POSTING__PENDING,
  [POSTING_APPLICATIONS_NAV_TITLES.HIRED] : EMBER_ROUTE_NAMES.POSTING__HIRED,
  [POSTING_APPLICATIONS_NAV_TITLES.DECLINED] : EMBER_ROUTE_NAMES.POSTING__DECLINED
};
